import { useField } from "formik";
import React from "react";
import { Textarea, Field,  FieldLabel, InlineNotification } from '@blueprint/ui';

import { GenericFieldProps } from "./common";

type TextareaFieldProps = {
    placeholder?: string;
    maxLength?: number;
    isAllowed?: (value: string) => boolean;
    required?: boolean;
    defaultValue?: string;
} & GenericFieldProps;

const TextareaField = ({
    className,
    name,
    label,
    maxLength,
    isAllowed,
    autoFocus,
    required,
    defaultValue,
}: TextareaFieldProps): JSX.Element => {
    const [field, meta, helpers] = useField(name);

    return (
        <>
        <Field>
            <FieldLabel marginBottom='6px' htmlFor={name}>{label}</FieldLabel>
            <Textarea
                onChange={
                    isAllowed
                        ? (e: React.ChangeEvent<any>) =>
                        isAllowed(e.target.value) &&
                        helpers.setValue(e.target.value)
                        : field.onChange
                }
                defaultValue={defaultValue}
                isInvalid={!!meta.error}
                maxLength={maxLength}
                style={{ height: "125px" }}
                autoFocus={autoFocus}
                width={'100%'}
                aria-label={label}
                aria-describedby={`notification-help-${name}`}
                required={required}
            />
        </Field>
            {meta.error && (
                <InlineNotification variant="warning" id={`notification-help-${name}`}>{meta.error}</InlineNotification>
            )}
        </>
    );
};

export default TextareaField;
